export default __webpack_public_path__ + "static/media/Dr-Abhishek-new.2b8cfc33.jpg";